var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusDisableOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41 0.860352L3 2.27035L5.77 5.04035H5.35C2.34 5.36035 0 7.91035 0 11.0004C0 14.3104 2.69 17.0004 6 17.0004H17.73L19.73 19.0004L21.14 17.5904L4.41 0.860352ZM24 12.0004C24 9.36035 21.95 7.22035 19.35 7.04035C18.67 3.59035 15.64 1.00035 12 1.00035C10.67 1.00035 9.43 1.36035 8.35 1.97035L9.84 3.46035C10.51 3.17035 11.23 3.00035 12 3.00035C15.04 3.00035 17.5 5.46035 17.5 8.50035V9.00035H19C20.66 9.00035 22 10.3404 22 12.0004C22 12.9904 21.52 13.8504 20.79 14.4004L22.2 15.8104C23.29 14.8904 24 13.5404 24 12.0004ZM2 11.0004C2 13.2104 3.79 15.0004 6 15.0004H15.73L7.73 7.00035H6C3.79 7.00035 2 8.79035 2 11.0004Z",
    fill: "#727E84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDisableOffline);
export default __webpack_public_path__ + "static/media/status_disable_offline.5e4778f4c28d6f256baf8314e6427b1e.svg";
export { ForwardRef as ReactComponent };